import { get } from 'lodash';

import { init as browseInit } from './browseComponent';
import { init as primaryContentSlotInit } from './primaryContentSlotComponent';
import { init as categoryLandingSlotsComponentInit } from './landingContentSlotsComponent';
import { init as initBrandsIndex } from './brandsIndexComponent';
import { init as initH1Component } from './categoryH1Component';
import { init as initTitleComponent } from './categoryTitleComponent';
import { init as initProductCountComponent } from './productCountComponent';
import { init as initSeoCopyComponent } from './seoCopyComponent';
import { init as ugcComponentInit } from '../../../core/js/components/ugcComponent';
import { init as facetComponentManagerInit } from './facetComponentManager';
import { init as shoppableProductInit } from './shoppableProductComponent';

import { favoriteClicked } from '../../../core/js/utils/favoritesUtils';

import template from 'category-layout.j2';

import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';

import localStorage from '../../../core/js/utils/cacheUtils';
import { BACK_TO_CATALOG_DATA_KEY, BACK_TO_CATALOG_DATA_TTL } from '../../../core/js/constants';

import { launchAsyncQuickshop } from '@product/js/utils/asyncLaunchers';
import { categoryQuickshopOptions } from '../utils/categoryQuickshopOptions';
import { calculatePosition } from '@core/js/utils/inlineContentSlotUtils';

export function attachEvents(store) {

    $(window).on(this.scopedEvent('resize'), _.debounce((e) => {
        // We have to hide any visible inline content slots on resize in order to reposition them
        // correctly
        hideContentSlotsAndResetPosition();
        positionInlineContentSlots(store);
    }, 200));

    $(document).on(this.scopedEvent('touchend click'),
        this.scopedSelector('.js-category-grid .js-product-tile-control-quickshop'), (e) => {
            e.preventDefault();

            const productIndex = $(e.target).parents('.js-product-tile')
                .attr('data-product-index');
            const records = _.map(store.getState().category.products.records, (tile) => tile.allMeta.tile);

            launchAsyncQuickshop(store, categoryQuickshopOptions, e, records, productIndex);
        });

    // eslint-disable-next-line arrow-body-style
    $(document).on('click', '.js-category-grid .js-favorite-toggle', (e) => {
        return favoriteClicked(store, e);
    });

    $(document).on('keydown', '.js-category-grid .js-favorite-toggle', (e) => {
        if (e.keyCode === 13) {
            favoriteClicked(store, e);
        }
    });
}

export function positionInlineContentSlots(store) {
    const categoryGrid = document.getElementsByClassName('s-category-grid')[0];
    let contentSlots = Array.from(document.querySelectorAll('.js-category__inline-content-slot'));
    const pageInfo = _.get(store.getState(), 'category.products.pageInfo')
    const offset = _.get(pageInfo, 'recordStart', 1) - 1;
    const maxPositionIndex = (_.get(pageInfo, 'recordEnd') - 1) - offset;

    contentSlots = contentSlots.sort(sortInlineContentSlots);

    for(let i = 0; i < contentSlots.length; i++) {
        let contentSlotPosition = Number(contentSlots[i].attributes['data-qa-inline-content-position'].value);
        const targetedPosition = contentSlotPosition - offset - 1;
        const visibleSlots = contentSlots.filter((slot) => {
            return !slot.attributes['hidden'];
        }).length;

        if (targetedPosition >= -1) {
            calculatePosition(contentSlots[i], targetedPosition, categoryGrid, visibleSlots, maxPositionIndex);
        }
    }
}

export function hideContentSlotsAndResetPosition() {
    const categoryGrid = document.getElementsByClassName('s-category-grid')[0];
    const contentSlots = Array.from(document.querySelectorAll('.js-category__inline-content-slot'));

    for( let i = 0; i < contentSlots.length; i++) {
        const contentSlot = categoryGrid.removeChild(contentSlots[i]);
        contentSlot.setAttribute('hidden', true);
        categoryGrid.prepend(contentSlot);
    }
}

export function sortInlineContentSlots(slotA, slotB) {
    const orderOfA = Number(slotA.attributes['data-qa-content-order'].value);
    const orderOfB = Number(slotB.attributes['data-qa-content-order'].value);

    if (orderOfA < orderOfB) {
        return -1;
    } else if (orderOfA > orderOfB) {
        return 1;
    }
    return 0;
}

export function onStateChange(store, watchValue, oldValue, newValue) {
    const isSearch = get(store.getState(), 'category.isSearch');
    const searchTerm = get(store.getState(), 'category.searchTerm');

    if (watchValue === 'category.catalogRequestUrl' && isSearch && searchTerm) {
        const backToCatalogData = {
            'backToCatalogUrl': newValue,
            'pageName': searchTerm
        };

        localStorage.set(BACK_TO_CATALOG_DATA_KEY, backToCatalogData, BACK_TO_CATALOG_DATA_TTL);
    } else if (watchValue !== 'category.catalogRequestUrl') {
        this.render(store, this, {});
    }
}

export function init(store, overrides = {}) {
    const config = {
        children: [
            browseInit,
            primaryContentSlotInit,
            categoryLandingSlotsComponentInit,
            initBrandsIndex,
            initProductCountComponent,
            initH1Component,
            initTitleComponent,
            initSeoCopyComponent,
            [ugcComponentInit, {
                feature: 'category',
                loader: {
                    onWindow: true
                }
            }],
            facetComponentManagerInit,
            shoppableProductInit
        ],
        templateLocation: '.dom-category-layout',
        watch: ['category.templateOptions.typeCode', 'category.catalogRequestUrl'],
        name: 'categoryComponent',
        attachEvents: attachEvents,
        template: template,
        onStateChange: onStateChange,
        rebind: true
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
